var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.customerCode"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextInput", {
                model: {
                  value: _vm.model.customerCode,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "customerCode", $$v)
                  },
                  expression: "model.customerCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.commercialTitle"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextInput", {
                model: {
                  value: _vm.model.commercialTitle,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "commercialTitle", $$v)
                  },
                  expression: "model.commercialTitle"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.customerType"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextDropdown", {
                attrs: { "lookup-key": "CUSTOMER_TYPE", "get-lookup": true },
                model: {
                  value: _vm.model.customerType,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "customerType", $$v)
                  },
                  expression: "model.customerType"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.customerGroup"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextDropdown", {
                attrs: { "lookup-key": "CUSTOMER_GROUP", "get-lookup": true },
                model: {
                  value: _vm.model.customerGroup,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "customerGroup", $$v)
                  },
                  expression: "model.customerGroup"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.customerKind"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextDropdown", {
                attrs: { "lookup-key": "CUSTOMER_KIND", "get-lookup": true },
                model: {
                  value: _vm.model.customerKind,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "customerKind", $$v)
                  },
                  expression: "model.customerKind"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "NextFormGroup",
            {
              attrs: {
                title: _vm.$t("insert.loyalty.customerClass"),
                md: "4",
                lg: "4",
                required: false
              }
            },
            [
              _c("NextDropdown", {
                attrs: { "lookup-key": "CUSTOMER_CLASS", "get-lookup": true },
                model: {
                  value: _vm.model.customerClass,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "customerClass", $$v)
                  },
                  expression: "model.customerClass"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", md: "12" } },
            [
              _c(
                "b-form-group",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-1",
                      attrs: {
                        id: "searchButton",
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isLoading
                      },
                      on: { click: _vm.filter }
                    },
                    [
                      _vm.isLoading
                        ? _c(
                            "span",
                            [_c("b-spinner", { attrs: { small: "" } })],
                            1
                          )
                        : _c("span", [
                            _c("i", { staticClass: "fa fa-list" }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("insert.loyalty.search"))
                            )
                          ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "12" } },
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("insert.loyalty.searchedCustomers")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "text-right" },
                    [
                      _vm.selectedSearchCustomerList &&
                      _vm.selectedSearchCustomerList.length > 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                id: "addButton",
                                size: "sm",
                                variant: "success"
                              },
                              on: { click: _vm.add }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("insert.loyalty.add")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                ref: "searchedList",
                attrs: {
                  id: "searched-customer-list",
                  fields: _vm.customerListFields,
                  items: _vm.searchedCustomerList,
                  "select-mode": "multi",
                  responsive: "",
                  selectable: true,
                  bordered: "",
                  "tbody-tr-class": "bg-white",
                  "current-page": _vm.searchedCurrentPage,
                  "per-page": _vm.perPage
                },
                on: { "row-selected": _vm.searchSelected },
                scopedSlots: _vm._u([
                  {
                    key: "head()",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(data.label)) +
                            "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(selection)",
                    fn: function(row) {
                      return [
                        _c("span", [
                          _c("i", {
                            class: row.rowSelected
                              ? "fa fa-check-circle success-color"
                              : "fa fa-check-circle gray-color"
                          })
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("b-pagination", {
                attrs: {
                  id: "searched-pagination",
                  "total-rows": _vm.searchedCustomerList
                    ? _vm.searchedCustomerList.length
                    : 0,
                  "per-page": _vm.perPage,
                  "aria-controls": "searched-customer-list"
                },
                model: {
                  value: _vm.searchedCurrentPage,
                  callback: function($$v) {
                    _vm.searchedCurrentPage = $$v
                  },
                  expression: "searchedCurrentPage"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-col",
                { attrs: { cols: "12", md: "12" } },
                [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("insert.loyalty.currentCustomers")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { staticClass: "text-right" },
                    [
                      _vm.selectedCurrentCustomerList &&
                      _vm.selectedCurrentCustomerList.length > 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-1",
                              attrs: {
                                id: "addButton",
                                size: "sm",
                                variant: "success"
                              },
                              on: { click: _vm.remove }
                            },
                            [
                              _c("i", { staticClass: "fa fa-trash" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("insert.loyalty.remove")) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                attrs: {
                  id: "current-customer-list",
                  fields: _vm.customerListFields,
                  items: _vm.currentCustomerList
                    ? _vm.currentCustomerList.filter(function(c) {
                        return c.RecordState !== 4
                      })
                    : [],
                  "select-mode": "multi",
                  responsive: "",
                  selectable: true,
                  bordered: "",
                  "tbody-tr-class": "bg-white",
                  "current-page": _vm.currentCurrentPage,
                  "per-page": _vm.perPage
                },
                on: { "row-selected": _vm.currentSelected },
                scopedSlots: _vm._u([
                  {
                    key: "head()",
                    fn: function(data) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t(data.label)) +
                            "\n        "
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(selection)",
                    fn: function(row) {
                      return [
                        _c("span", [
                          _c("i", {
                            class: row.rowSelected
                              ? "fa fa-check-circle success-color"
                              : "fa fa-check-circle gray-color"
                          })
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("b-pagination", {
                attrs: {
                  id: "current-pagination",
                  "total-rows": _vm.currentCustomerList
                    ? _vm.currentCustomerList.length
                    : 0,
                  "per-page": _vm.perPage,
                  "aria-controls": "current-customer-list"
                },
                model: {
                  value: _vm.currentCurrentPage,
                  callback: function($$v) {
                    _vm.currentCurrentPage = $$v
                  },
                  expression: "currentCurrentPage"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bc6fc47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc6fc47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Loyalty/MultipleCustomerOperations.vue
// module id = null
// module chunks = 